<mat-form-field>
  <input matInput [matDatepicker]="dp" placeholder="Elija un año" [formControl]="yearCtrl" readonly>
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event, dp)" panelClass="month-picker">
  </mat-datepicker>
</mat-form-field>
